import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'sonner';
import { useLanguage } from './LanguageContext';

const WishlistContext = createContext();

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within WishlistProvider');
  }
  return context;
};

export const WishlistProvider = ({ children }) => {
  const { language } = useLanguage();
  const [wishlist, setWishlist] = useState([]);

  // Load wishlist from localStorage on mount
  useEffect(() => {
    const savedWishlist = localStorage.getItem('allmx_wishlist');
    if (savedWishlist) {
      try {
        setWishlist(JSON.parse(savedWishlist));
      } catch (error) {
      }
    }
  }, []);

  // Save wishlist to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('allmx_wishlist', JSON.stringify(wishlist));
  }, [wishlist]);

  const addToWishlist = (product) => {
    if (wishlist.find(item => item.sku === product.sku)) {
      toast.info(language === 'it' ? 'Prodotto già nei preferiti' : 'Product already in wishlist');
      return;
    }
    setWishlist(prev => [...prev, product]);
    toast.success(language === 'it' ? '❤️ Aggiunto ai preferiti!' : '❤️ Added to wishlist!', { duration: 2000 });
  };

  const removeFromWishlist = (sku) => {
    setWishlist(prev => prev.filter(item => item.sku !== sku));
    toast.success(language === 'it' ? 'Rimosso dai preferiti' : 'Removed from wishlist', { duration: 2000 });
  };

  const isInWishlist = (sku) => {
    return wishlist.some(item => item.sku === sku);
  };

  const clearWishlist = () => {
    setWishlist([]);
    toast.success(language === 'it' ? 'Preferiti svuotati' : 'Wishlist cleared', { duration: 2000 });
  };

  return (
    <WishlistContext.Provider value={{ 
      wishlist, 
      addToWishlist, 
      removeFromWishlist, 
      isInWishlist,
      clearWishlist
    }}>
      {children}
    </WishlistContext.Provider>
  );
};
